export const MuiDialog = {
    styleOverrides: {
        paper: {
            borderRadius: 8
        }
    }
}
